import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt, faRocket, faUser } from '@fortawesome/free-solid-svg-icons';
import useAuthStore from '../../store/authStore';

function HeaderTrabajadores() {
  const { logout, trabajador } = useAuthStore();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  // Obtener el ID del trabajador para la navegación
  const trabajadorId = trabajador?._id || trabajador?.trabajadorId;
  const dashboardPath = trabajadorId ? `/trabajador/${trabajadorId}/dashboard` : '/';

  return (
    <header className="bg-white shadow-lg border-b border-gray-100 relative z-50">
      <div className="max-w-7xl mx-auto px-4 py-4">
        <div className="flex justify-between items-center">
          {/* Logo */}
          <div className="flex items-center">
            <Link to={dashboardPath} className="flex items-center space-x-3 hover:opacity-80 transition-opacity">
              <img
                src="/logos/logopng.png"
                alt="PetitPrime Logo"
                className="h-10 w-auto"
              />
              <span className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
                PetitPrime
              </span>
            </Link>
          </div>

          {/* User Info and Logout */}
          <div className="flex items-center space-x-4">
            <div className="flex items-center space-x-2 px-3 py-2 bg-blue-50 text-blue-700 rounded-xl">
              <div className="w-6 h-6 bg-gradient-to-r from-blue-500 to-indigo-500 rounded-full flex items-center justify-center">
                <FontAwesomeIcon icon={faUser} className="text-white text-xs" />
              </div>
              <span className="text-sm font-medium">Trabajador</span>
            </div>

            <button
              onClick={handleLogout}
              className="flex items-center space-x-2 px-4 py-2 bg-red-500 hover:bg-red-600 text-white rounded-xl transition-colors duration-300 font-medium"
            >
              <FontAwesomeIcon icon={faSignOutAlt} className="text-sm" />
              <span className="hidden sm:inline">Salir</span>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}

export default HeaderTrabajadores;
